import { Spin } from "antd";
import styled from "styled-components";

const LoadingRoot = styled.div<{ $minHeight: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${(p) => p.$minHeight};
  padding: 48px 24px;
  gap: 16px;
  box-sizing: border-box;
`;

const LoadingTip = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-align: center;
  max-width: 360px;
`;

type OperatorPageLoadingProps = {
  /** Shown under the spinner so the page does not look stuck blank. */
  tip?: string;
  minHeight?: string;
};

/**
 * Full-content loading state for operator hub pages (Client Tracker, Downloads, etc.).
 * Prefer this over a tiny top-padded Spin on a white page.
 */
export function OperatorPageLoading({
  tip = "Loading…",
  minHeight = "50vh",
}: OperatorPageLoadingProps): JSX.Element {
  return (
    <LoadingRoot $minHeight={minHeight} role="status" aria-live="polite" aria-busy="true">
      <Spin size="large" />
      {tip ? <LoadingTip>{tip}</LoadingTip> : null}
    </LoadingRoot>
  );
}
